import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/sections/Hero";
import Services from "./components/sections/Services";
import About from "./components/sections/About";
import Stats from "./components/sections/Stats";
import Portfolio from "./components/sections/Portfolio";
import Team from "./components/sections/Team";
import Testimonials from "./components/sections/Testimonials";
import Contact from "./components/sections/Contact";
import Footer from "./components/Footer";
import PolicyPage from "./components/sections/PolicyPage";
import AdminRouter from "./admin/AdminRouter";
import ScrollToTop from "./components/ui/ScrollToTop";

function MainPage() {
  return (
    <div className="bg-dark min-h-screen overflow-x-hidden">
      <Navbar />
      <Hero />
      <Services />
      <Stats />
      <About />
      <Portfolio />
      <Team />
      <Testimonials />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/privacy-policy" element={<PolicyPage type="privacy" />} />
        <Route path="/refund-policy" element={<PolicyPage type="refund" />} />
        <Route path="/terms-and-conditions" element={<PolicyPage type="terms" />} />
        <Route path="/legal-policy" element={<PolicyPage type="legal" />} />
        <Route path="/admin/*" element={<AdminRouter />} />
      </Routes>
    </BrowserRouter>
  );
}
